<template>
  <div>
    <div id="app" class="accordion">
      <div class="row">
        <div class="col-sm-6 align-self-center">
          <visual
            :current-kreisslino="currentKreisslino"
            :img-u-r-l="imgURL"/>
        </div>
        <div class="col-sm-6">
          <div style="display: none;" class="print">
            <b>Varianten:</b><br>
            Fußbettung: {{currentKreisslino.bedding.variantTitle}}<br>
            Modell: {{currentKreisslino.belt.variantTitle}}<br>
            <br>
            <b>Farben:</b><br>
            Fußbettung: {{currentKreisslino.bedding.currentColor.variant+" "}}<br>

            {{currentKreisslino.belt.title}}: {{currentKreisslino.belt.currentColor.variant}}<br>
            <span v-if="currentKreisslino.secondBelt">{{currentKreisslino.secondBelt.title}}: {{currentKreisslino.secondBelt.currentColor.variant}}<br></span>
            <span v-if="currentKreisslino.bridge">{{currentKreisslino.bridge.title}}: {{currentKreisslino.bridge.currentColor.variant}}<br></span>
            <span
              v-if="currentKreisslino.sock.visible">Decksohle: {{currentKreisslino.sock.currentColor.variant}}<br></span>
            Laufsohle: {{currentKreisslino.outSole.currentColor.variant}}
            <span v-if="currentKreisslino.midSole.visible">Zwischensohle: {{currentKreisslino.midSole.currentColor.variant}}<br></span>
          </div>
          <br>
          <menuComp :identifier="'bedding'" class="card no-print" title="Bettungen">
            <div v-if="!bigResolution" data-parent="#app" id="bedding" :class="hideOnInatialize"
                 class="col-11 col-md-12 collapse">
              <div class="card-body">
                <carousel :navigateTo=0 class="offset-1" :perPage="2" :navigationEnabled="true"
                          :paginationEnabled="false">
                  <slide v-for="(item,index) in beddings" :key="item.code">
                    <menu-item
                      :key="item.code"
                      :title="item.variantTitle"
                      :selected=currentKreisslino.bedding
                      :img-u-r-l="imgURL"
                      :ite=item
                      :height="currentKreisslino.bedding.variant"
                      :code="item.code"
                      :thumbnail="item.thumbnail"
                      @click="setBedding(item)"
                      class="bedding"></menu-item>
                  </slide>
                </carousel>
              </div>
            </div>
            <div v-else class="row">
              <menu-item v-for="(item) in beddings"
                         class="bedding col-sm-3"
                         :key="item.code"
                         :title="item.variantTitle"
                         :selected=currentKreisslino.bedding
                         :img-u-r-l="imgURL"
                         :ite=item
                         :height="currentKreisslino.bedding.variant"
                         :code="item.code"
                         :thumbnail="item.thumbnail"
                         @click="setBedding(item)"
              />
            </div>
          </menuComp>
          <br>
          <menuComp class="card no-print" :identifier="'belt'" title="Modell">
            <div v-if="!bigResolution" data-parent="#app" id="belt" :class="hideOnInatialize"
                 class="col-11 col-md-12 collapse">
              <div class="card-body">
                <carousel :navigateTo=0 class="offset-1" :perPage="2" :navigationEnabled="true"
                          :paginationEnabled="false">
                  <slide v-for="(item) in kreisslElements.belt.variants" :key="item.code">
                    <menu-item
                      @click="setBelt(item)"
                      class="belt"
                      :key="item.code"
                      :img-u-r-l="imgURL"
                      :title="item.variantTitle"
                      :selected="currentKreisslino.belt"
                      :ite=item
                      :height="currentKreisslino.bedding.variant"
                      :code="item.code"
                      :type="item.type"
                      :thumbnail="item.thumbnail"
                    ></menu-item>
                  </slide>
                </carousel>
              </div>
            </div>
            <div v-else class="row">
              <menu-item v-for="(item) in kreisslElements.belt.variants"
                         @click="setBelt(item)"
                         class="belt col-sm-3"
                         :key="item.code"
                         :img-u-r-l="imgURL"
                         :title="item.variantTitle"
                         :selected="currentKreisslino.belt"
                         :ite=item
                         :height="currentKreisslino.bedding.variant"
                         :code="item.code"
                         :type="item.type"
                         :thumbnail="item.thumbnail"/>
            </div>
          </menuComp>
          <br>
        </div>
      </div>
      <menuComp class="card no-print" :identifier="'colorPick'" title="Farben">
        <div v-if="!bigResolution" data-parent="#app" id="colorPick" :class="hideOnInatialize"
             class="col-11 col-md-12 collapse">
          <div class="card-body">
            <carousel :navigateTo=navigateTo class="offset-1" :perPage="2" :navigationEnabled="true"
                      :paginationEnabled="false">
              <slide v-for="(item,index) in currentKreisslino" :key="item.code">
                <menu-item
                  @click="setColorPicker(index)"
                  :class="index === colorPicker.isType? 'font-weight-bold':''"
                  class="colorable"
                  :height="currentKreisslino.bedding.variant"
                  :title="item.title"
                  :key="item.code"
                  :ite=item
                  :code="item.code"
                  :thumbnail="item.menuImage"/>
              </slide>
            </carousel>
          </div>
        </div>
        <div v-else class="row text-center">
          <menu-item v-for="(item, index) in currentKreisslino"
                     :class="index === colorPicker.isType? 'font-weight-bold':''"
                     @click="setColorPicker(index)"
                     class="colorable col-sm-2"
                     :img-u-r-l="imgURL"
                     :height="currentKreisslino.bedding.variant"
                     :key="item.code"
                     :ite=item
                     :title="item.title"
                     :code="item.code"
                     :thumbnail="item.menuImage"/>
        </div>
      </menuComp>
      <br>
      <hr class="no-print">
      <br>
      <div class="col-11 col-md-12 no-print">
        <carousel ref="carousel" :navigateTo=navigateTo class="offset-1" :scrollPerPage="false"
                  :perPageCustom="[[0, 3], [768, 8]]"
                  :navigationEnabled="true"
                  :paginationEnabled="false">
          <slide v-for="(item,index) in colorPicker.colors" :key="item.code">
            <menu-item
              @click="setColor(item,index)"
              :class="currentKreisslino[colorPicker.isType] && item === currentKreisslino[colorPicker.isType].currentColor? 'font-weight-bold':''"
              class="color"
              :height="currentKreisslino.bedding.variant"
              :title="item.variant"
              :ite=item
              :code="item.code"
              :thumbnail="item.thumbnail"/>
          </slide>
        </carousel>
      </div>
    </div>
    <br>
    <div class="no-print">
      <p><b>Folgende Modelle haben wir für Sie schon vorkonfiguriert:</b></p><br>
      <div class="row">
        <div class="col-3 col-lg-2">
          <a @click="changeModel('firstModel')"><img width="100%" class="img-responsive"
                                                     :src="imgURL+'Buttonbilder/konfi_modellvorschau_1.png'"></a></div>
        <div class="col-3 col-lg-2"><a @click="changeModel('secondModel')"><img width="100%" class="img-responsive"
                                                                                :src="imgURL+'Buttonbilder/konfi_modellvorschau_2.png'"></a>
        </div>
        <div class="col-3 col-lg-2"><a @click="changeModel('thirdModel')"><img width="100%" class="img-responsive"
                                                                               :src="imgURL+'Buttonbilder/konfi_modellvorschau_3.png'"></a>
        </div>
      </div>
      <br>
      <br>
      <button style="float: right" @click="printShoe" class="btn btn-primary">Drucken</button>
      <br>
      <br>
    </div>
  </div>
</template>
<script>

  import Vue from 'vue';

  import Bedding from "./components/bedding"
  import MenuItem from "./components/menuItem"
  import OutSole from "./components/outSole"
  import MidSole from "./components/midSole"
  import Belt from "./components/belt"
  import Visual from "./components/visual";
  import MenuComp from "./components/menuComp";
  import SecondBelt from "./components/secondBelt";
  import Hiddeninput from "./components/hiddeninput";
  import Sock from "./components/sock";
  import Dummy from "./components/dummies";

  import {Carousel, Slide} from 'vue-carousel';

  import UUID from 'uuid/v1';
  import SelectOptions from "./components/selectOptions";

  export default {
    name: 'App',
    components: {
      SelectOptions,
      MenuComp,
      MenuItem,
      Visual,
      Bedding,
      OutSole,
      MidSole,
      Belt,
      SecondBelt,
      Carousel,
      Slide,
      Hiddeninput,
      Sock,
      Dummy
    },
    created() {
      Object.values(this.kreisslElements).forEach((part) => {
        let setUUID = (item) => item.code = UUID();
        part.variants.forEach(setUUID);
        part.colors.forEach(setUUID);
      });
      this.beddings = this.kreisslElements.bedding.variants;
      this.setBedding();
      this.setOutSole();
      this.setMidSole();
      this.setBelt();
      this.setColorPicker();
      this.setPresets();
    },
    mounted() {
      window.addEventListener('resize', this.onResize)
      let width = document.body.clientWidth;
      this.bigResolution = width >= 576;
      setTimeout(() => {
        this.isVisible = false;
      }, 100);


    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize)
    },
    data() {
      return {
        navigateTo: 0,
        imgURL: "static/images/",
        colorPicker: {},
        bigResolution: true,
        isDual: false,
        isVisible: true,
        beddings: {},
        presets: {
          firstModel: {
            title: "Modell 1",
            bedding: {},
            belt: {},
            bridge: {},
            outSole: {},
            sock: {
              code: "",
              removable: true,
              variantTitle: "Hoch",
              visible: false,
              variant: "high",
              title: "Decksohle (optional)",
              thumbnail: "",
              menuImage: "menu-icons/flach_bettung.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
            midSole: {
              code: "",
              removable: true,
              title: "Zwischensohle (optional)",
              visible: false,
              variant: "",
              variantTitle: "",
              thumbnail: "",
              menuImage: "menu-icons/flach_midsole.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
          },
          secondModel: {
            title: "Modell 2",
            bedding: {},
            belt: {},
            bridge: {},
            outSole: {},
            sock: {
              code: "",
              removable: true,
              variantTitle: "Hoch",
              visible: false,
              variant: "high",
              title: "Decksohle (optional)",
              thumbnail: "",
              menuImage: "menu-icons/flach_bettung.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
            midSole: {
              code: "",
              removable: true,
              title: "Zwischensohle (optional)",
              visible: false,
              variant: "",
              variantTitle: "",
              thumbnail: "",
              menuImage: "menu-icons/flach_midsole.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
          },
          thirdModel: {
            title: "Modell 3",
            bedding: {},
            belt: {},
            secondBelt: {},
            outSole: {},
            sock: {
              code: "",
              removable: true,
              variantTitle: "Hoch",
              visible: false,
              variant: "high",
              title: "Decksohle (optional)",
              thumbnail: "",
              menuImage: "menu-icons/flach_bettung.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
            midSole: {
              code: "",
              removable: true,
              title: "Zwischensohle (optional)",
              visible: false,
              variant: "",
              variantTitle: "",
              thumbnail: "",
              menuImage: "menu-icons/flach_midsole.svg",
              image: "",
              currentColor: {
                title: "schwarz",
                variant: "01",
                code: "",
                thumbnail: ""
              },
            },
          }
        },
        currentKreisslino: {
          bedding: {
            code: "",
            visible: true,
            variantTitle: "Hoch",
            variant: "high",
            title: "Fußbettung",
            thumbnail: "",
            menuImage: "menu-icons/kreisslinos_bettung-full.svg",
            image: "",
            currentColor: {
              title: "schwarz",
              variant: "01",
              code: "",
              thumbnail: ""
            },
          },
          belt: {
            code: "",
            title: "Lederriemen oben",
            variant: "x",
            visible: true,
            wideness: "fat",
            belt: "belt",
            variantTitle: "Quattro breit",
            thumbnail: "",
            menuImage: "menu-icons/flach_y-fat.svg",
            image: "",
            currentColor: {
              title: "schwarz samt",
              variant: "03",
              code: "",
              thumbnail: ""
            },
          },
          secondBelt: {
            code: "",
            title: "Lederriemen unten",
            visible: true,
            variant: "x",
            wideness: "fat",
            belt: "secondBelt",
            variantTitle: "Quattro breit",
            thumbnail: "",
            menuImage: "menu-icons/flach_y-thin.svg",
            image: "",
            currentColor: {
              title: "schwarz samt",
              variant: "03",
              code: "",
              thumbnail: ""
            },
          },
          bridge: {
            code: "",
            title: "Zehensteg",
            visible: true,
            variant: "",
            variantTitle: "Quattro breit",
            thumbnail: "",
            menuImage: "menu-icons/flach_y-fat.svg",
            image: "",
            currentColor: {
              title: "schwarz",
              variant: "01",
              code: "",
              thumbnail: ""
            },
          },
          outSole: {
            code: "",
            title: "Laufsohle",
            visible: true,
            variant: "B_01",
            variantTitle: "",
            thumbnail: "",
            menuImage: "menu-icons/flach_laufsohle.svg",
            image: "",
            currentColor: {
              title: "schwarz",
              variant: "B_01",
              code: "",
              thumbnail: ""
            },
          },
          sock: {
            code: "",
            removable: true,
            variantTitle: "Hoch",
            visible: false,
            variant: "high",
            title: "Decksohle (optional)",
            thumbnail: "",
            menuImage: "menu-icons/flach_bettung.svg",
            image: "",
            currentColor: {
              title: "schwarz",
              variant: "01",
              code: "",
              thumbnail: ""
            },
          },
          midSole: {
            code: "",
            removable: true,
            title: "Zwischensohle (optional)",
            visible: false,
            variant: "",
            variantTitle: "",
            thumbnail: "",
            menuImage: "menu-icons/flach_midsole.svg",
            image: "",
            currentColor: {
              title: "schwarz",
              variant: "01",
              code: "",
              thumbnail: ""
            },
          },
        },
        kreisslElements: {
          bedding: {
            colors: [
              {
                title: "schwarz",
                variant: "01",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/01.png"
              },
              {
                title: "grau",
                variant: "02",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/02.png"
              },
              {
                title: "türkis",
                variant: "03",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/03.png"
              },
              {
                title: "schlamm",
                variant: "04",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/04.png"
              },
              {
                title: "braun",
                variant: "05",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/05.png"
              },
              {
                title: "senf",
                variant: "06",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/06.png"
              },
              {
                title: "blau",
                variant: "10",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/10.png"
              },
              {
                title: "weiß",
                variant: "12",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/12.png"
              },
              {
                title: "eisblau",
                variant: "76",
                code: "",
                type: "bedding",
                thumbnail: "menu-icons/Fußbettung/76.png"
              }
            ],
            variants: [
              {
                code: "",
                variantTitle: "Hoch",
                variant: "high",
                title: "Fußbettung",
                thumbnail: "menu-icons/hoch.svg",
                image: "",
              },
              {
                code: "",
                variantTitle: "Flach",
                variant: "flat",
                title: "Fußbettung",
                thumbnail: "menu-icons/flach.svg",
                image: "",
              }
            ],
          },
          outSole: {
            colors: [
              {
                title: "Standard schwarz",
                variant: "B_01",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/S_01.png",
                image: ""
              }, {
                title: "Standard braun",
                variant: "B_05",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/S_05.png",
                image: ""
              }, {
                title: "Birkenstock schwarz",
                variant: "D_08",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/B_01.png",
                image: ""
              }, {
                title: "Birkenstock braun",
                variant: "D_08",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/B_05.png",
                image: ""
              }, {
                title: "Stone schwarz",
                variant: "S_01",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/D_06.png",
                image: ""
              }, {
                title: "Stone grau",
                variant: "S_05",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/D_08.png",
                image: ""
              }, {
                title: "Astrostar schwarz",
                variant: "C_01",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_01.png",
                image: ""
              }, {
                title: "Astrostar grau",
                variant: "C_02",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_02.png",
                image: ""
              }, {
                title: "Astrostar dunkelblau",
                variant: "C_10",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_10.png",
                image: ""
              }, {
                title: "Astrostar hellgrau",
                variant: "C_11",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_11.png",
                image: ""
              }, {
                title: "Astrostar weiß",
                variant: "C_12",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_12.png",
                image: ""
              }, {
                title: "Astrostar pink",
                variant: "C_17",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_17.png",
                image: ""
              }, {
                title: "Astrostar sand",
                variant: "C_19",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_19.png",
                image: ""
              }, {
                title: "Astrostar hellbraun",
                variant: "C_35",
                code: "",
                type: "outsole",
                thumbnail: "menu-icons/Laufsohle/C_35.png",
                image: ""
              }],
            variants: [
              {
                code: "",
                title: "Laufsohle",
                variant: "",
                variantTitle: "",
                thumbnail: "menu-icons/flach_laufsohle.svg",
                image: "",
              }],
          },
          midSole: {
            colors: [
              {
                title: "schwarz",
                variant: "01",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/01.png",
                image: ""
              }, {
                title: "grau",
                variant: "02",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/02.png",
                image: ""
              }, {
                title: "kork",
                variant: "03",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/03.png",
                image: ""
              }, {
                title: "bordeaux",
                variant: "04",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/04.png",
                image: ""
              }, {
                title: "braun",
                variant: "05",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/05.png",
                image: ""
              }, {
                title: "hellgrün",
                variant: "06",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/06.png",
                image: ""
              }, {
                title: "royalblau",
                variant: "08",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/08.png",
                image: ""
              }, {
                title: "olive",
                variant: "09",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/09.png",
                image: ""
              }, {
                title: "dunkelblau",
                variant: "10",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/10.png",
                image: ""
              }, {
                title: "gelb",
                variant: "11",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/11.png",
                image: ""
              }, {
                title: "schlamm",
                variant: "12",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/12.png",
                image: ""
              }, {
                title: "türkis",
                variant: "13",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/13.png",
                image: ""
              }, {
                title: "blau",
                variant: "14",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/14.png",
                image: ""
              }, {
                title: "senf",
                variant: "15",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/15.png",
                image: ""
              }, {
                title: "smaragdgrün",
                variant: "16",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/16.png",
                image: ""
              }, {
                title: "pink",
                variant: "17",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/17.png",
                image: ""
              }, {
                title: "grau-hellbraun, marmor",
                variant: "23",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/23.png",
                image: ""
              },
              // {
              //   title: "sand, marmor",
              //   variant: "24",
              //   code: "",
              //   type: "midsole",
              //   thumbnail: "menu-icons/Zwischensohle/24.png",
              //   image: ""
              // },
              {
                title: "blau, marmor",
                variant: "25",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/25.png",
                image: ""
              }, {
                title: "schwarz-rot-gelb, marmor",
                variant: "26",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/26.png",
                image: ""
              }, {
                title: "schwarz-rot, marmor",
                variant: "29",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/29.png",
                image: ""
              }, {
                title: "leder",
                variant: "88",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/88.png",
                image: ""
              }],
            variants: [
              {
                code: "",
                title: "Zwischensohle (optional)",
                variant: "",
                variantTitle: "",
                thumbnail: "menu-icons/flach_midsole.svg",
                image: "",
              }]
          },
          dummy: {
            colors: [
              {
                title: "schwarz",
                variant: "01",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/01.png",
                image: ""
              }, {
                title: "grau",
                variant: "02",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/02.png",
                image: ""
              }, {
                title: "kork",
                variant: "03",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/03.png",
                image: ""
              }, {
                title: "bordeaux",
                variant: "04",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/04.png",
                image: ""
              }, {
                title: "braun",
                variant: "05",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/05.png",
                image: ""
              }, {
                title: "hellgrün",
                variant: "06",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/06.png",
                image: ""
              }, {
                title: "royalblau",
                variant: "08",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/08.png",
                image: ""
              }, {
                title: "olive",
                variant: "09",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/09.png",
                image: ""
              }, {
                title: "dunkelblau",
                variant: "10",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/10.png",
                image: ""
              }, {
                title: "gelb",
                variant: "11",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/11.png",
                image: ""
              }, {
                title: "schlamm",
                variant: "12",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/12.png",
                image: ""
              }, {
                title: "türkis",
                variant: "13",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/13.png",
                image: ""
              }, {
                title: "blau",
                variant: "14",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/14.png",
                image: ""
              }, {
                title: "senf",
                variant: "15",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/15.png",
                image: ""
              }, {
                title: "smaragdgrün",
                variant: "16",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/16.png",
                image: ""
              }, {
                title: "pink",
                variant: "17",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/17.png",
                image: ""
              }, {
                title: "grau-hellbraun, marmor",
                variant: "23",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/23.png",
                image: ""
              }, {
                title: "sand, marmor",
                variant: "24",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/24.png",
                image: ""
              }, {
                title: "blau, marmor",
                variant: "25",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/25.png",
                image: ""
              }, {
                title: "schwarz-rot-gelb, marmor",
                variant: "26",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/26.png",
                image: ""
              }, {
                title: "schwarz-rot, marmor",
                variant: "29",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/29.png",
                image: ""
              }, {
                title: "leder",
                variant: "88",
                code: "",
                type: "midsole",
                thumbnail: "menu-icons/Zwischensohle/88.png",
                image: ""
              }],
            variants: [
              {
                code: "",
                title: "Zwischensohle (optional)",
                variant: "",
                variantTitle: "",
                thumbnail: "menu-icons/flach_midsole.svg",
                image: "",
              }]
          },
          belt: {
            colors: [
              // {
              //   title: "Paisley schwarz",
              //   variant: "01",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/01.png"
              // },
              // {
              //   title: "schwarz samt",
              //   variant: "03",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/03.png"
              // },
              {
                title: "bordeaux",
                variant: "04",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/04.png"
              },
              {
                title: "schwarz glatt",
                variant: "06",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/06.png"
              },
              {
                title: "dunkelblau",
                variant: "10",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/10.png"
              },
              {
                title: "korallenrot",
                variant: "11",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/11.png"
              },
              {
                title: "weiß",
                variant: "12",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/12.png"
              },
              {
                title: "türkis",
                variant: "16",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/16.png"
              },
              // {
              //   title: "pink kroko",
              //   variant: "17",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/17.png"
              // },
              {
                title: "lack-schwarz",
                variant: "18",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/18.png",
                image: ""
              }, {
                title: "Schlange silber",
                variant: "20",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/20.png",
                image: ""
              }, {
                title: "Rosen pink",
                variant: "21",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/21.png",
                image: ""
              }, {
                title: "Rosen vintage",
                variant: "22",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/22.png",
                image: ""
              }, {
                title: "70er Jahre Blumen",
                variant: "23",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/23.png",
                image: ""
              }, {
                title: "dunkelbraun",
                variant: "24",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/24.png",
                image: ""
              }, {
                title: "leopard",
                variant: "25",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/25.png",
                image: ""
              },
              // {
              //   title: "silber mamoriert",
              //   variant: "28",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/28.png",
              //   image: ""
              // }, {
              //   title: "anthrazit marmoriert",
              //   variant: "29",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/29.png",
              //   image: ""
              // },
              {
                title: "Lack Weinrot",
                variant: "32",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/32.png",
                image: ""
              }, {
                title: "Nubuk mittelbraun",
                variant: "37",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/37.png",
                image: ""
              }, {
                title: "Nubuk rehbraun",
                variant: "38",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/38.png",
                image: ""
              }, {
                title: "Nubuk sand",
                variant: "39",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/39.png",
                image: ""
              }, {
                title: "Rind braun",
                variant: "40",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/40.png",
                image: ""
              }, {
                title: "Rind schwarz",
                variant: "41",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/41.png",
                image: ""
              },
              // {
              //   title: "Gold Schwarz Stoff",
              //   variant: "43",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/43.png",
              //   image: ""
              // },
              // {
              //   title: "schwarz-kroko",
              //   variant: "45",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/45.png",
              //   image: ""
              // },
              {
                title: "dunkelblau nubuk",
                variant: "51",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/51.png",
                image: ""
              }, {
                title: "ziegelrot, gepunktet",
                variant: "54",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/54.png",
                image: ""
              }, {
                title: "Muster schwarz bunt",
                variant: "55",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/55.png",
                image: ""
              }, {
                title: "gelb, bunte Herzen",
                variant: "58",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/58.png",
                image: ""
              }, {
                title: "kronblumenblau",
                variant: "60",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/60.png",
                image: ""
              }, {
                title: "mango",
                variant: "61",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/61.png",
                image: ""
              }, {
                title: "lila",
                variant: "62",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/62.png",
                image: ""
              }, {
                title: "rosa",
                variant: "63",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/63.png",
                image: ""
              },
              // {
              //   title: "himmelblau",
              //   variant: "68",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/68.png",
              //   image: ""
              // },
              {
                title: "smaragd, kroko",
                variant: "70",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/70.png",
                image: ""
              }, {
                title: "karibik",
                variant: "71",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/71.png",
                image: ""
              }, {
                title: "kroko grau-schwarz-weiß",
                variant: "77",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/77.png",
                image: ""
              }, {
                title: "kroko blau-schwarz-weiß",
                variant: "78",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/78.png",
                image: ""
              }, {
                title: "almwiese, bunt",
                variant: "79",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/79.png",
                image: ""
              }, {
                title: "sommerwiese, bunt",
                variant: "80",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/80.png",
                image: ""
              }
              // , {
              //   title: "schokobraun",
              //   variant: "82",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/82.png",
              //   image: ""
              // }
              , {
                title: "sand-weiß gepunktet",
                variant: "86",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/86.png",
                image: ""
              }, {
                title: "kroko-lila-weiß",
                variant: "89",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/89.png",
                image: ""
              }, {
                title: "kroko-ziegelrot",
                variant: "90",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/90.png",
                image: ""
              }
              // , {
              //   title: "silber-schwarz rosen",
              //   variant: "91",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/91.png",
              //   image: ""
              // }
              , {
                title: "hellblau, opt. perforiert",
                variant: "92",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/92.png",
                image: ""
              }, {
                title: "dunkelblau gestreift",
                variant: "93",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/93.png",
                image: ""
              },
              //  {
              //   title: "schwarz, kroko fein",
              //   variant: "94",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/94.png",
              //   image: ""
              // },
              //  {
              //   title: "metallic grün",
              //   variant: "97",
              //   code: "",
              //   type: "belt",
              //   thumbnail: "menu-icons/Lederriemen/97.png",
              //   image: ""
              // },
              {
                title: "metallic orange",
                variant: "99",
                code: "",
                type: "belt",
                thumbnail: "menu-icons/Lederriemen/99.png",
                image: ""
              }
            ],
            variants: [
              {
                code: "",
                title: "Lederriemen",
                variant: "Y",
                wideness: "fat",
                variantTitle: "Kreißlino breit",
                thumbnail: "menu-icons/flach_y-fat.svg",
                image: "",
              },
              {
                code: "",
                title: "Lederriemen",
                variant: "Y",
                wideness: "thin",
                variantTitle: "Kreißlino schmal",
                thumbnail: "menu-icons/flach_y-thin.svg",
                image: "",
              },
              {
                code: "",
                title: "Lederriemen oben",
                variant: "X",
                wideness: "fat",
                variantTitle: "Quattro breit",
                thumbnail: "menu-icons/flach_x-fat.svg",
                image: "",
              },
              {
                code: "",
                title: "Lederriemen oben",
                variant: "X",
                wideness: "thin",
                variantTitle: "Quattro schmal",
                thumbnail: "menu-icons/flach_x-thin.svg",
                image: "",
              },
              // {
              //   code: "",
              //   title: "Lederriemen",
              //   variant: "dual",
              //   wideness: "fat",
              //   variantTitle: "Dummy breit",
              //   thumbnail: "menu-icons/flach_x-fat.svg",
              //   image: "",
              // },
              {
                code: "",
                title: "Lederriemen vorne",
                variant: "Dual",
                wideness: "fat",
                variantTitle: "Duo",
                thumbnail: "menu-icons/dual/dual.svg",
                image: "",
              }
            ],
          },
          secondBelt: {
            colors: [
              // {
              //   title: "Paisley schwarz",
              //   variant: "01",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/01.png"
              // },
              // {
              //   title: "schwarz samt",
              //   variant: "03",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/03.png"
              // },
              {
                title: "bordeaux",
                variant: "04",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/04.png"
              },
              {
                title: "schwarz glatt",
                variant: "06",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/06.png"
              },
              {
                title: "dunkelblau",
                variant: "10",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/10.png"
              },
              {
                title: "korallenrot",
                variant: "11",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/11.png"
              },
              {
                title: "weiß",
                variant: "12",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/12.png"
              },
              {
                title: "türkis",
                variant: "16",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/16.png"
              },
              {
                title: "pink kroko",
                variant: "17",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/17.png"
              },
              {
                title: "lack-schwarz",
                variant: "18",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/18.png",
                image: ""
              }, {
                title: "Schlange silber",
                variant: "20",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/20.png",
                image: ""
              }, {
                title: "Rosen pink",
                variant: "21",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/21.png",
                image: ""
              }, {
                title: "Rosen vintage",
                variant: "22",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/22.png",
                image: ""
              }, {
                title: "70er Jahre Blumen",
                variant: "23",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/23.png",
                image: ""
              }, {
                title: "dunkelbraun",
                variant: "24",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/24.png",
                image: ""
              }, {
                title: "leopard",
                variant: "25",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/25.png",
                image: ""
              },
              // {
              //   title: "silber mamoriert",
              //   variant: "28",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/28.png",
              //   image: ""
              // }, {
              //   title: "anthrazit marmoriert",
              //   variant: "29",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/29.png",
              //   image: ""
              // },
              {
                title: "Lack Weinrot",
                variant: "32",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/32.png",
                image: ""
              }, {
                title: "Nubuk mittelbraun",
                variant: "37",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/37.png",
                image: ""
              }, {
                title: "Nubuk rehbraun",
                variant: "38",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/38.png",
                image: ""
              }, {
                title: "Nubuk sand",
                variant: "39",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/39.png",
                image: ""
              }, {
                title: "Rind braun",
                variant: "40",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/40.png",
                image: ""
              }, {
                title: "Rind schwarz",
                variant: "41",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/41.png",
                image: ""
              }, {
                title: "Gold Schwarz Stoff",
                variant: "43",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/43.png",
                image: ""
              }, {
                title: "schwarz-kroko",
                variant: "45",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/45.png",
                image: ""
              }, {
                title: "dunkelblau nubuk",
                variant: "51",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/51.png",
                image: ""
              }, {
                title: "ziegelrot, gepunktet",
                variant: "54",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/54.png",
                image: ""
              }, {
                title: "Muster schwarz bunt",
                variant: "55",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/55.png",
                image: ""
              }, {
                title: "gelb, bunte Herzen",
                variant: "58",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/58.png",
                image: ""
              }, {
                title: "kronblumenblau",
                variant: "60",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/60.png",
                image: ""
              }, {
                title: "mango",
                variant: "61",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/61.png",
                image: ""
              }, {
                title: "lila",
                variant: "62",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/62.png",
                image: ""
              }, {
                title: "rosa",
                variant: "63",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/63.png",
                image: ""
              }, {
                title: "himmelblau",
                variant: "68",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/68.png",
                image: ""
              }, {
                title: "smaragd, kroko",
                variant: "70",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/70.png",
                image: ""
              }, {
                title: "karibik",
                variant: "71",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/71.png",
                image: ""
              }, {
                title: "kroko grau-schwarz-weiß",
                variant: "77",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/77.png",
                image: ""
              }, {
                title: "kroko blau-schwarz-weiß",
                variant: "78",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/78.png",
                image: ""
              }, {
                title: "almwiese, bunt",
                variant: "79",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/79.png",
                image: ""
              }, {
                title: "sommerwiese, bunt",
                variant: "80",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/80.png",
                image: ""
              },
              //   {
              //   title: "schokobraun",
              //   variant: "82",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/82.png",
              //   image: ""
              // },
                {
                title: "sand-weiß gepunktet",
                variant: "86",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/86.png",
                image: ""
              }, {
                title: "kroko-lila-weiß",
                variant: "89",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/89.png",
                image: ""
              }, {
                title: "kroko-ziegelrot",
                variant: "90",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/90.png",
                image: ""
              }
              // , {
              //   title: "silber-schwarz rosen",
              //   variant: "91",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/91.png",
              //   image: ""
              // }
              , {
                title: "hellblau, opt. perforiert",
                variant: "92",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/92.png",
                image: ""
              }, {
                title: "dunkelblau gestreift",
                variant: "93",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/93.png",
                image: ""
              },
              //  {
              //   title: "schwarz, kroko fein",
              //   variant: "94",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/94.png",
              //   image: ""
              // },
              //  {
              //   title: "metallic grün",
              //   variant: "97",
              //   code: "",
              //   type: "secondbelt",
              //   thumbnail: "menu-icons/Lederriemen/97.png",
              //   image: ""
              // },
              {
                title: "metallic orange",
                variant: "99",
                code: "",
                type: "secondbelt",
                thumbnail: "menu-icons/Lederriemen/99.png",
                image: ""
              }
            ],
            variants: [
              {
                code: "",
                title: "Lederriemen unten",
                variant: "X",
                wideness: "fat",
                variantTitle: "Quattro breit",
                thumbnail: "menu-icons/flach_x-fat_2.svg",
                image: "",
              },
              {
                code: "",
                title: "Lederriemen unten",
                variant: "X",
                wideness: "thin",
                variantTitle: "Quattro schmal",
                thumbnail: "menu-icons/flach_x-thin_2.svg",
                image: "",
              },
              // {
              //   code: "",
              //   title: "Lederriemen 2",
              //   variant: "dual",
              //   wideness: "thin",
              //   variantTitle: "Dummy breit",
              //   thumbnail: "menu-icons/flach_x-fat_2.svg",
              //   image: "",
              // },
              {
                code: "",
                title: "Lederriemen hinten",
                variant: "Dual",
                wideness: "fat",
                variantTitle: "Duo",
                thumbnail: "menu-icons/dual/dual_back.svg",
                image: "",
              },
            ],
          },
          bridge: {
            colors: [
              {
                title: "schwarz",
                variant: "01",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/01.jpg",
              },
              {
                title: "grau",
                variant: "02",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/02.jpg",
              }, {
                title: "hellgrau",
                variant: "03",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/03.jpg",
              }, {
                title: "dunkelbraun",
                variant: "05",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/05.jpg",
              }, {
                title: "hellgrün",
                variant: "06",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/06.jpg",
              }, {
                title: "pflaume",
                variant: "07",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/07.jpg",
              }, {
                title: "lila",
                variant: "08",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/08.jpg",
              }, {
                title: "dunkelgrün",
                variant: "09",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/09.jpg",
              }, {
                title: "dunkelblau",
                variant: "10",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/10.jpg",
              }, {
                title: "gelb",
                variant: "11",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/11.jpg",
              }, {
                title: "weiß",
                variant: "12",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/12.jpg",
              }, {
                title: "orange",
                variant: "13",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/13.jpg",
              }, {
                title: "rot",
                variant: "14",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/14.jpg",
              }, {
                title: "lindgrün",
                variant: "15",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/15.jpg",
              }, {
                title: "hellblau",
                variant: "16",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/16.jpg",
              }, {
                title: "pink",
                variant: "17",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/17.jpg",
              }, {
                title: "sand",
                variant: "19",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/19.jpg",
              }, {
                title: "rost",
                variant: "20",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/20.jpg",
              }, {
                title: "schokobraun",
                variant: "21",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/21.jpg",
              }, {
                title: "gelb gepunktet",
                variant: "22",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/22.jpg",
              }, {
                title: "hellblau gepunktet",
                variant: "23",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/23.jpg",
              }, {
                title: "hellblau matt",
                variant: "24",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/24.jpg",
              }, {
                title: "petrol",
                variant: "25",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/25.jpg",
              }, {
                title: "mittelblau",
                variant: "26",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/26.jpg",
              }, {
                title: "blau-lila",
                variant: "27",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/27.jpg",
              }, {
                title: "olive matt",
                variant: "28",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/28.jpg",
              }, {
                title: "olive",
                variant: "29",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/29.jpg",
              }, {
                title: "mint glitzerstreifen",
                variant: "30",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/30.jpg",
              }, {
                title: "rot matt",
                variant: "31",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/31.jpg",
              }, {
                title: "bordeaux",
                variant: "32",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/32.jpg",
              }, {
                title: "pink matt",
                variant: "33",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/33.jpg",
              }, {
                title: "rosa matt",
                variant: "34",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/34.jpg",
              }, {
                title: "flieder matt",
                variant: "35",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/35.jpg",
              }, {
                title: "pflaume struktur",
                variant: "36",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/36.jpg",
              }, {
                title: "lila matt",
                variant: "37",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/37.jpg",
              }, {
                title: "grau-beige gepunktet",
                variant: "38",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/38.jpg",
              }, {
                title: "grau-beige matt",
                variant: "39",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/39.jpg",
              }, {
                title: "schlamm struktur",
                variant: "40",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/40.jpg",
              }, {
                title: "grau-beige/gold",
                variant: "41",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/41.jpg",
              }, {
                title: "schokobraun/gold",
                variant: "42",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/42.jpg",
              }, {
                title: "schlamm",
                variant: "83",
                type: "bridge",
                thumbnail: "menu-icons/Zehenstege/83.jpg",
              }
            ],
            variants: [
              {
                code: "",
                title: "Zehensteg",
                variant: "Y",
                wideness: "fat",
                variantTitle: "Kreißlino breit",
                thumbnail: "menu-icons/flach_y-fat_bridge.svg",
                image: "",
              },
              {
                code: "",
                title: "Zehensteg",
                variant: "Y",
                wideness: "thin",
                variantTitle: "Kreißlinos schmal",
                thumbnail: "menu-icons/flach_y-thin_bridge.svg",
                image: "",
              }]
          },
          sock: {
            colors: [
              {
                title: "schwarz",
                variant: "01",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/01.png",
                image: ""
              }, {
                title: "grau",
                variant: "02",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/02.png",
                image: ""
              }, {
                title: "kork",
                variant: "03",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/03.png",
                image: ""
              }, {
                title: "bordeaux",
                variant: "04",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/04.png",
                image: ""
              }, {
                title: "braun",
                variant: "05",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/05.png",
                image: ""
              }, {
                title: "hellgrün",
                variant: "06",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/06.png",
                image: ""
              }, {
                title: "royalblau",
                variant: "08",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/08.png",
                image: ""
              }, {
                title: "olive",
                variant: "09",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/09.png",
                image: ""
              }, {
                title: "dunkelblau",
                variant: "10",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/10.png",
                image: ""
              }, {
                title: "gelb",
                variant: "11",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/11.png",
                image: ""
              }, {
                title: "schlamm",
                variant: "12",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/12.png",
                image: ""
              }, {
                title: "türkis",
                variant: "13",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/13.png",
                image: ""
              }, {
                title: "blau",
                variant: "14",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/14.png",
                image: ""
              }, {
                title: "senf",
                variant: "15",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/15.png",
                image: ""
              }, {
                title: "smaragdgrün",
                variant: "16",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/16.png",
                image: ""
              }, {
                title: "pink",
                variant: "17",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/17.png",
                image: ""
              }, {
                title: "grau-hellbraun, marmor",
                variant: "23",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/23.png",
                image: ""
              },
              // {
              //   title: "sand, marmor",
              //   variant: "24",
              //   code: "",
              //   type: "sock",
              //   thumbnail: "menu-icons/Zwischensohle/24.png",
              //   image: ""
              // },
              {
                title: "blau, marmor",
                variant: "25",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/25.png",
                image: ""
              }, {
                title: "schwarz-rot-gelb, marmor",
                variant: "26",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/26.png",
                image: ""
              }, {
                title: "schwarz-rot, marmor",
                variant: "29",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/29.png",
                image: ""
              }, {
                title: "leder",
                variant: "88",
                code: "",
                type: "sock",
                thumbnail: "menu-icons/Zwischensohle/88.png",
                image: ""
              }],
            variants: [
              {
                code: "",
                variantTitle: "Hoch",
                variant: "high",
                title: "Decksohle (optional)",
                thumbnail: "menu-icons/hoch.svg",
                image: "",
              },
              {
                code: "",
                variantTitle: "Flach",
                variant: "flat",
                title: "Decksohle (optional)",
                thumbnail: "menu-icons/flach.svg",
                image: "",
              }
            ],
          }
        },
        colorPickerOrder: ["bedding", "belt", "secondBelt", "bridge", "outSole", "sock", "midSole"]
      }
    },
    computed: {
      hideOnInatialize() {
        return {
          show: this.isVisible,
        }
      }
    },
    methods: {
      onResize(event) {
        let width = document.body.clientWidth;
        this.bigResolution = width > 576;
      },
      handleChange(e) {
        if (e.target.options.selectedIndex > -1) {
          let changedItem = this.kreisslElements.bedding.variants.find((r) => {
            return e.target.options[e.target.options.selectedIndex].value === r.variantTitle
          });
          this.setBedding(changedItem)
        }
      },
      setBedding(bedding) {
        if (!bedding) {
          bedding = this.kreisslElements.bedding.variants[0];
        }
        let result = {};
        Object.assign(result, this.currentKreisslino.bedding, bedding);
        Vue.set(this.currentKreisslino, 'bedding', result);
      },
      setOutSole(outSole) {
        if (!outSole) {
          outSole = this.kreisslElements.outSole.variants[0];
        }
        let result = {};
        Object.assign(result, this.currentKreisslino.outSole, outSole);
        Vue.set(this.currentKreisslino, 'outSole', result);
      },
      setMidSole(midSole) {
        if (!midSole) {
          midSole = this.kreisslElements.midSole.variants[0];
        }
        let result = {};
        Object.assign(result, this.currentKreisslino.midSole, midSole);
        Vue.set(this.currentKreisslino, 'midSole', result);
      },
      setBelt(belt) {
        if (!belt) {
          belt = this.kreisslElements.belt.variants[0];
        }
        let result = {};
        Object.assign(result, this.currentKreisslino.belt, belt);
        Vue.set(this.currentKreisslino, 'belt', result);

        if (!this.currentKreisslino.belt.currentColor) {
          Vue.set(this.currentKreisslino.belt, 'currentColor', this.kreisslElements.belt.colors[0]);
        }

        if (belt.variant.toUpperCase() === "X" || belt.variant.toUpperCase() === "DUAL") {
          this.setSecondBelt();
          this.setBridge(null);
          Vue.set(this.currentKreisslino.belt, "menuImage", "menu-icons/flach_" + belt.variant.toLocaleLowerCase() + "-" + this.currentKreisslino.belt.wideness + "_1.svg");
          if (belt.variant.toUpperCase() === "DUAL") {
            Vue.set(this.currentKreisslino.belt, "menuImage", "menu-icons/dual/dual_front.svg")
          }
        } else {
          this.setBridge();
          this.setSecondBelt(null);
          Vue.set(this.currentKreisslino.belt, "menuImage", "menu-icons/flach_" + belt.variant.toLocaleLowerCase() + "-" + this.currentKreisslino.belt.wideness + ".svg")
        }

        if (belt.variant.toUpperCase() === "DUAL") {
          this.setBedding(this.kreisslElements.bedding[0]);
          this.beddings = this.kreisslElements.bedding.variants.slice(0, 1);
        } else {
          this.beddings = this.kreisslElements.bedding.variants;
        }

        if (!this.currentKreisslino[this.colorPicker.isType]) {
          this.setColorPicker();
        }
        let temp = this.currentKreisslino;
        this.currentKreisslino = {};
        let size = Object.keys(temp).length;

        for (let i = 0; i <= size; i++) {
          if (temp[this.colorPickerOrder[i]]) {
            Vue.set(this.currentKreisslino, [this.colorPickerOrder[i]], temp[this.colorPickerOrder[i]]);
            // this.currentKreisslino[this.colorPickerOrder[i]] = temp[this.colorPickerOrder[i]];
          }
        }
      },
      setBridge(bridge) {

        if (bridge === null) {
          return Vue.delete(this.currentKreisslino, 'bridge');
        }
        if (!bridge) {
          bridge = this.kreisslElements.bridge.variants.find((r) => {
            return this.currentKreisslino.belt.wideness === r.wideness
          });
        }
        let result = {};
        Object.assign(result, this.currentKreisslino.bridge, bridge);
        Vue.set(this.currentKreisslino, 'bridge', result);
        if (!this.currentKreisslino.bridge.currentColor) {
          Vue.set(this.currentKreisslino.bridge, 'currentColor', this.kreisslElements.bridge.colors[0])
        }
        Vue.set(this.currentKreisslino.bridge, "menuImage", "menu-icons/flach_y-" + this.currentKreisslino.bridge.wideness + "_bridge.svg")
      },
      setSecondBelt(secondBelt) {
        if (secondBelt === null) {
          Vue.delete(this.currentKreisslino, 'secondBelt');
          return null;
        }

        if (!secondBelt) {
          if (this.currentKreisslino.belt.variant === "X") {
            if (this.currentKreisslino.belt.wideness === "fat") {
              secondBelt = this.kreisslElements.secondBelt.variants[0]
            } else {
              secondBelt = this.kreisslElements.secondBelt.variants[1]
            }
          } else {
            secondBelt = this.kreisslElements.secondBelt.variants[2]
          }

        }
        let result = {};
        Object.assign(result, this.currentKreisslino.secondBelt, secondBelt);

        if (!result.currentColor) {
          result.currentColor = this.currentKreisslino.belt.currentColor
        }

        Vue.set(this.currentKreisslino, 'secondBelt', result);
        if (!this.currentKreisslino.secondBelt.currentColor) {
          Vue.set(this.currentKreisslino.secondBelt, 'currentColor', this.kreisslElements.secondBelt.colors[0])
        }
        console.log("->", this.currentKreisslino.secondBelt.variant);
        if (this.currentKreisslino.belt.variant.toUpperCase() === "DUAL") {
          Vue.set(this.currentKreisslino.secondBelt, "menuImage", "menu-icons/dual/dual_back.svg")
        } else {
          Vue.set(this.currentKreisslino.secondBelt, "menuImage", "menu-icons/flach_" + this.currentKreisslino.secondBelt.variant.toLowerCase() + "-" + this.currentKreisslino.secondBelt.wideness + "_2.svg");
        }
      },
      setColorPicker(type) {
        if (!type) {
          type = Object.keys(this.kreisslElements)[0];
        }
        if (this.$refs.carousel !== undefined) this.$refs.carousel.goToPage(0);
        let temp;
        if (this.colorPicker.colors) {
          temp = this.colorPicker.colors.length;
        }
        switch (type) {
          case "sock":
            Vue.set(this.currentKreisslino.sock, "visible", true);
            break;
          case "midSole":
            Vue.set(this.currentKreisslino.midSole, "visible", true);
            break;
        }

        this.colorPicker = this.kreisslElements[type];
        this.colorPicker.isType = type;
        // this.reInit()
        // if (temp) {
        //   if (this.colorPicker.colors.length < temp) {
        //     console.log("ping")
        //   }
        // }
      },
      setColor(item, index) {
        if (!item) {
          item = this.colorPicker.colors[0];
        }

        Vue.set(this.currentKreisslino[this.colorPicker.isType], 'currentColor', item);
        // let result = {};
        // Object.assign(result, this.currentKreisslino.bridge, item);
        // this.currentKreisslino.bridge = result;
      },
      getElement(type, variant, wideness, color) {
        // let temp = {};
        // Vue.util.extend(temp, );

        let bedding;
        if (typeof variant === 'string') {
          if (wideness) {
            bedding = this.kreisslElements[type].variants.find((el) => el.variant === variant && el.wideness === wideness);
          } else {
            bedding = this.kreisslElements[type].variants.find((el) => el.variant === variant);
          }

        }
        if (!bedding) {
          bedding = this.kreisslElements[type].variants[0];
        }

        if (typeof color === 'string') {
          bedding.currentColor = this.kreisslElements[type].colors.find((el) => el.variant === color);
        } else {
          bedding.currentColor = this.kreisslElements[type].colors[0];
        }

        return bedding;
      },
      setPresets() {

        this.presets.firstModel = {
          bedding: JSON.parse(JSON.stringify(this.getElement('bedding', 'high', null, "76"))),
          belt: JSON.parse(JSON.stringify(this.getElement('belt', 'Y', 'fat', "16"))),
          bridge: JSON.parse(JSON.stringify(this.getElement('bridge', 'Y', 'fat', "07"))),
          outSole: JSON.parse(JSON.stringify(this.getElement('outSole', null, null, "C_17")))
        };

        this.presets.secondModel = {
          bedding: JSON.parse(JSON.stringify(this.getElement('bedding', 'flat', null, "06"))),
          belt: JSON.parse(JSON.stringify(this.getElement('belt', 'Y', 'thin', "55"))),
          bridge: JSON.parse(JSON.stringify(this.getElement('bridge', 'Y', 'thin', "27"))),
          outSole: JSON.parse(JSON.stringify(this.getElement('outSole', null, null, "C_10")))
        };

        this.presets.thirdModel = {
          bedding: JSON.parse(JSON.stringify(this.getElement('bedding', 'flat', null, "12"))),
          belt: JSON.parse(JSON.stringify(this.getElement('belt', 'X', 'fat', "10"))),
          secondBelt: JSON.parse(JSON.stringify(this.getElement('belt', 'X', 'fat', "11"))),
          bridge: JSON.parse(JSON.stringify(this.getElement('bridge', 'Y', 'fat', "07"))),
          outSole: JSON.parse(JSON.stringify(this.getElement('outSole', null, null, "C_10"))),
          sock: JSON.parse(JSON.stringify(this.getElement('sock', null, null, '02')))
        };


        // let temp = {};
        // Vue.util.extend(temp, this.kreisslElements);

        // console.log("tempTest", temp)

        // Vue.util.extend(this.presets.firstModel.bedding, temp.bedding.variants[0]);
        // this.presets.firstModel.bedding = temp.bedding.variants[0];
        // this.presets.firstModel.bedding.currentColor = temp.bedding.colors[8];
        // Vue.util.extend(this.presets.firstModel.belt, temp.belt.variants[0]);
        // this.presets.firstModel.belt.currentColor = temp.belt.colors[7];
        // Vue.util.extend(this.presets.firstModel.bridge, temp.bridge.variants[0]);
        // this.presets.firstModel.bridge.currentColor = temp.bridge.colors[5];
        // Vue.util.extend(this.presets.firstModel.outSole, temp.outSole.variants[0]);
        // this.presets.firstModel.outSole.currentColor = temp.outSole.colors[11];

        // Vue.util.extend(this.presets.secondModel.bedding, temp.bedding.variants[1]);
        // // this.presets.secondModel.bedding = temp.bedding.variants[1];
        // this.presets.secondModel.bedding.currentColor = temp.bedding.colors[5];
        // Vue.util.extend(this.presets.secondModel.belt, temp.belt.variants[1]);
        // this.presets.secondModel.belt.currentColor = temp.belt.colors[28];
        // Vue.util.extend(this.presets.secondModel.bridge, temp.bridge.variants[1]);
        // this.presets.secondModel.bridge.currentColor = temp.bridge.colors[23];
        // Vue.util.extend(this.presets.secondModel.outSole, temp.outSole.variants[0]);
        // this.presets.secondModel.outSole.currentColor = temp.outSole.colors[8];
        //
        // Vue.util.extend(this.presets.thirdModel.bedding, temp.bedding.variants[1]);
        // // this.presets.thirdModel.bedding = temp.bedding.variants[1];
        // this.presets.thirdModel.bedding.currentColor = temp.bedding.colors[7];
        // Vue.util.extend(this.presets.thirdModel.belt, temp.belt.variants[2]);
        // this.presets.thirdModel.belt.currentColor = temp.belt.colors[4];
        // Vue.util.extend(this.presets.thirdModel.secondBelt, temp.secondBelt.variants[0]);
        // this.presets.thirdModel.secondBelt.currentColor = temp.secondBelt.colors[5];
        // Vue.util.extend(this.presets.thirdModel.outSole, temp.outSole.variants[0]);
        // this.presets.thirdModel.outSole.currentColor = temp.outSole.colors[8];
        // Vue.util.extend(this.presets.thirdModel.sock, temp.sock.variants[0]);
        // this.presets.thirdModel.sock.currentColor = temp.sock.colors[1];

      },

      printShoe() {
        window.print();
      },
      changeModel(i) {

        // this.currentKreisslino = this.presets[i]
        //
        //
        // return


        let chosenModel = this.presets[i];
        // console.log(this.presets[i]);
        // this.currentKreisslino = this.presets[i];
        // this.setBedding();
        this.setBedding(chosenModel.bedding);
        this.setBelt(chosenModel.belt);
        if (chosenModel.secondBelt) {
          this.setSecondBelt(chosenModel.secondBelt);
        } else {
          this.setBridge(chosenModel.bridge);
        }
        this.setOutSole(chosenModel.outSole);

        this.currentKreisslino.midSole.visible = false;
        this.currentKreisslino.midSole.currentColor = this.kreisslElements.midSole.colors[0];
        if (i === "thirdModel") {
          this.currentKreisslino.sock.visible = true;
          this.currentKreisslino.sock.currentColor = this.presets.thirdModel.sock.currentColor;
        } else {
          this.currentKreisslino.sock.visible = false;
          this.currentKreisslino.sock.currentColor = this.kreisslElements.sock.colors[0];
        }
      }
    }

  }
</script>


<style>
  hr {
    border: 1px solid;
  }

  .outsole, .midsole, .bedding, .belt, .bridge, .secondbelt {
    z-index: 2;
  }

  .colorable, .belt, .bedding, .color {
    cursor: pointer;
  }

  .wrapper > img {
    position: absolute;
    max-height: 100%;
  }

  .hidden {
    display: none;
  }

  .marked {
    /*border: solid blue;*/
    font-weight: 700 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue